import { useState, useRef, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";

import Sidebar from "../../shared/components/sidebar/Sidebar";
import Navbar from "../../shared/components/navbar/Navbar";
import { useHttpClient } from "../../shared/hooks/http-hook";
import { AuthContext } from "../../shared/context/auth-context";
import { ClinicaContext } from "../../shared/context/clinica-context";
import { useLoading } from "../../shared/context/LoadingContext";

import toast from "react-hot-toast";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import moment from "moment";
import "./RequisicaoExames.scss";

function RequisicaoExames() {
  const { startLoading, stopLoading } = useLoading();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formulaExpanded, setFormulaExpanded] = useState(false);
  const { sendRequest } = useHttpClient();
  const [clienteData, setClienteData] = useState();

  const clienteId = useParams().clienteId;
  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);
  const navigate = useNavigate();

  // Refs para campos do paciente
  const procedenciaRef = useRef(null);
  const diagnosticoRef = useRef(null);
  const naturalidadeRef = useRef(null);

  // Refs para exames de SANGUE
  const glVermelhoRef = useRef(null);
  const glVermelhoNotaRef = useRef(null);
  const glBrancosRef = useRef(null);
  const glBrancosNotaRef = useRef(null);
  const hemoglobinaRef = useRef(null);
  const hemoglobinaNotaRef = useRef(null);
  const hematocritoRef = useRef(null);
  const hematocritoNotaRef = useRef(null);
  const plaquetasRef = useRef(null);
  const plaquetasNotaRef = useRef(null);
  const pesqPlasmRef = useRef(null);
  const pesqPlasmNotaRef = useRef(null);
  const hivRef = useRef(null);
  const hivNotaRef = useRef(null);

  const velSedimentRef = useRef(null);
  const velSedimentNotaRef = useRef(null);
  const tHemorragiaRef = useRef(null);
  const tHemorragiaNotaRef = useRef(null);
  const tCoagulacaoRef = useRef(null);
  const tCoagulacaoNotaRef = useRef(null);
  const formulaRef = useRef(null);
  const formulaNotaRef = useRef(null);
  const hbsAgRef = useRef(null);
  const hbsAgNotaRef = useRef(null);

  // Refs para subcampos da fórmula
  const formulaNeutRef = useRef(null);
  const formulaEosinRef = useRef(null);
  const formulaBasRef = useRef(null);
  const formulaLinfRef = useRef(null);
  const formulaMonRef = useRef(null);
  const formulaNjRef = useRef(null);

  const glicemiaRef = useRef(null);
  const glicemiaNotaRef = useRef(null);
  const acidoUricoRef = useRef(null);
  const acidoUricoNotaRef = useRef(null);
  const amilaseRef = useRef(null);
  const amilaseNotaRef = useRef(null);

  const gotRef = useRef(null);
  const gotNotaRef = useRef(null);
  const bilirrTotalRef = useRef(null);
  const bilirrTotalNotaRef = useRef(null);
  const gamaGtRef = useRef(null);
  const gamaGtNotaRef = useRef(null);

  const gptRef = useRef(null);
  const gptNotaRef = useRef(null);
  const bilirrDirectaRef = useRef(null);
  const bilirrDirectaNotaRef = useRef(null);
  const fosfAlcalinaRef = useRef(null);
  const fosfAlcalinaNotaRef = useRef(null);

  const colesterolRef = useRef(null);
  const colesterolNotaRef = useRef(null);
  const ureiaRef = useRef(null);
  const ureiaNotaRef = useRef(null);

  const colLdlRef = useRef(null);
  const colLdlNotaRef = useRef(null);
  const triglicerideosRef = useRef(null);
  const triglicerideosNotaRef = useRef(null);

  const colHdlRef = useRef(null);
  const colHdlNotaRef = useRef(null);
  const creatininaRef = useRef(null);
  const creatininaNotaRef = useRef(null);

  const vdrlRef = useRef(null);
  const vdrlNotaRef = useRef(null);
  const tphaRef = useRef(null);
  const tphaNotaRef = useRef(null);
  const widalRef = useRef(null);
  const widalNotaRef = useRef(null);

  const pcrRef = useRef(null);
  const pcrNotaRef = useRef(null);
  const tasoRef = useRef(null);
  const tasoNotaRef = useRef(null);
  const frRaRef = useRef(null);
  const frRaNotaRef = useRef(null);

  // Refs para exames de URINA
  const urinaCaracteresRef = useRef(null);
  const urinaCaracteresNotaRef = useRef(null);
  const urinaGlicosuriaRef = useRef(null);
  const urinaGlicosuriaNotaRef = useRef(null);
  const urinaAlbuminaRef = useRef(null);
  const urinaAlbuminaNotaRef = useRef(null);
  const urinaDensidadeRef = useRef(null);
  const urinaDensidadeNotaRef = useRef(null);
  const urinaPhRef = useRef(null);
  const urinaPhNotaRef = useRef(null);
  const urinaAcetonaRef = useRef(null);
  const urinaAcetonaNotaRef = useRef(null);
  const urinaBilirrRef = useRef(null);
  const urinaBilirrNotaRef = useRef(null);
  const urinaLeucocitosRef = useRef(null);
  const urinaLeucocitosNotaRef = useRef(null);
  const urinaSangueRef = useRef(null);
  const urinaSangueNotaRef = useRef(null);
  const urinaSedimentoRef = useRef(null);
  const urinaSedimentoNotaRef = useRef(null);

  // Refs para FEZES
  const fezesRef = useRef(null);
  const fezesNotaRef = useRef(null);

  const handleCancel = () => {
    navigate(`/clientes/${clienteId}-requisicaoexames`);
  };

  const handleFormulaChange = () => {
    setFormulaExpanded(!formulaExpanded);
  };

  useEffect(() => {
    startLoading();
    const fetchCliente = async () => {
      try {
        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/clientes/${clienteId}?clinicaId=${clinica.clinica._id}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );
        setClienteData(response.cliente);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };

    fetchCliente();
  }, [sendRequest, clienteId, auth.token, clinica.clinica._id]);

  const calcularIdade = () => {
    if (!clienteData?.data_nasc) return { anos: 0, meses: 0 };
    const dtNascTemp = moment(clienteData.data_nasc, "DD-MM-YYYY");

    let anos = moment().year() - dtNascTemp.year();
    let meses = moment().month() - dtNascTemp.month();

    if (meses < 0) {
      anos--;
      meses += 12;
    }

    return { anos, meses };
  };

  /* ── Ler um campo que pode nao estar no ecra ──────────────────────────────
   *
   * Varias secoes do formulario sao recolhiveis -- a formula leucocitaria, por
   * exemplo, so existe no DOM quando `formulaExpanded` e verdadeiro. Com a
   * secao fechada, `ref.current` e `null`, e ler `.checked` ou `.value` dele
   * atirava um TypeError que caia no `catch` geral e saia como «Erro ao
   * processar dados».
   *
   * O efeito pratico era pior do que a mensagem: a requisicao NUNCA gravava
   * enquanto a secao estivesse fechada, e como o erro falava de «processar
   * dados» ninguem ligava as duas coisas -- acrescentar exames nao resolvia,
   * porque o problema nao era a falta deles.
   *
   * Campo que nao esta no ecra conta como nao preenchido, que e a verdade. */
  const marcado = (ref) => !!ref.current?.checked;
  const texto = (ref) => ref.current?.value || "";

  const onSubmit = async () => {
    startLoading();
    try {
      const formData = new FormData();

      // Dados básicos
      formData.append("criadoPor", auth.userId);
      formData.append("clienteId", clienteData._id);
      formData.append("clinica", clinica.clinica._id);
      formData.append("medico_responsavel", auth.userId);

      // Dados do paciente
      formData.append("morada", clienteData.endereco || "");
      formData.append("procedencia", texto(procedenciaRef));
      formData.append("diagnostico", texto(diagnosticoRef));
      formData.append("naturalidade", texto(naturalidadeRef) || "");

      // Exames de Sangue
      const examesSangue = {
        glVermelhos: marcado(glVermelhoRef),
        glVermelhosNota: texto(glVermelhoNotaRef),
        glBrancos: marcado(glBrancosRef),
        glBrancosNota: texto(glBrancosNotaRef),
        hemoglobina: marcado(hemoglobinaRef),
        hemoglobinaNota: texto(hemoglobinaNotaRef),
        hematocrito: marcado(hematocritoRef),
        hematocritoNota: texto(hematocritoNotaRef),
        plaquetas: marcado(plaquetasRef),
        plaquetasNota: texto(plaquetasNotaRef),
        pesqPlasmedio: marcado(pesqPlasmRef),
        pesqPlasmedioNota: texto(pesqPlasmNotaRef),
        hiv: marcado(hivRef),
        hivNota: texto(hivNotaRef),
        velSedimentacao: marcado(velSedimentRef),
        velSedimentacaoNota: texto(velSedimentNotaRef),
        tHemorragia: marcado(tHemorragiaRef),
        tHemorragiaNota: texto(tHemorragiaNotaRef),
        tCoagulacao: marcado(tCoagulacaoRef),
        tCoagulacaoNota: texto(tCoagulacaoNotaRef),
        formula: marcado(formulaRef),
        formulaNota: texto(formulaNotaRef),
        formulaNeut: formulaNeutRef.current?.value || "",
        formulaEosin: formulaEosinRef.current?.value || "",
        formulaBas: formulaBasRef.current?.value || "",
        formulaLinf: formulaLinfRef.current?.value || "",
        formulaMon: formulaMonRef.current?.value || "",
        formulaNj: formulaNjRef.current?.value || "",
        hbsAg: marcado(hbsAgRef),
        hbsAgNota: texto(hbsAgNotaRef),
        glicemia: marcado(glicemiaRef),
        glicemiaNota: texto(glicemiaNotaRef),
        acidoUrico: marcado(acidoUricoRef),
        acidoUricoNota: texto(acidoUricoNotaRef),
        amilase: marcado(amilaseRef),
        amilaseNota: texto(amilaseNotaRef),
        got: marcado(gotRef),
        gotNota: texto(gotNotaRef),
        bilirrTotal: marcado(bilirrTotalRef),
        bilirrTotalNota: texto(bilirrTotalNotaRef),
        gamaGt: marcado(gamaGtRef),
        gamaGtNota: texto(gamaGtNotaRef),
        gpt: marcado(gptRef),
        gptNota: texto(gptNotaRef),
        bilirrDirecta: marcado(bilirrDirectaRef),
        bilirrDirectaNota: texto(bilirrDirectaNotaRef),
        fosfAlcalina: marcado(fosfAlcalinaRef),
        fosfAlcalinaNota: texto(fosfAlcalinaNotaRef),
        colesterol: marcado(colesterolRef),
        colesterolNota: texto(colesterolNotaRef),
        ureia: marcado(ureiaRef),
        ureiaNota: texto(ureiaNotaRef),
        colLdl: marcado(colLdlRef),
        colLdlNota: texto(colLdlNotaRef),
        triglicerideos: marcado(triglicerideosRef),
        triglicerideosNota: texto(triglicerideosNotaRef),
        colHdl: marcado(colHdlRef),
        colHdlNota: texto(colHdlNotaRef),
        creatinina: marcado(creatininaRef),
        creatininaNota: texto(creatininaNotaRef),
        vdrl: marcado(vdrlRef),
        vdrlNota: texto(vdrlNotaRef),
        tpha: marcado(tphaRef),
        tphaNota: texto(tphaNotaRef),
        widal: marcado(widalRef),
        widalNota: texto(widalNotaRef),
        pcr: marcado(pcrRef),
        pcrNota: texto(pcrNotaRef),
        taso: marcado(tasoRef),
        tasoNota: texto(tasoNotaRef),
        frRa: marcado(frRaRef),
        frRaNota: texto(frRaNotaRef),
      };
      formData.append("examesSangue", JSON.stringify(examesSangue));

      // Exames de Urina
      const examesUrina = {
        caracteresGerais: marcado(urinaCaracteresRef),
        caracteresGeraisNota: texto(urinaCaracteresNotaRef),
        glicosuria: marcado(urinaGlicosuriaRef),
        glicosuriaNota: texto(urinaGlicosuriaNotaRef),
        albumina: marcado(urinaAlbuminaRef),
        albuminaNota: texto(urinaAlbuminaNotaRef),
        densidade: marcado(urinaDensidadeRef),
        densidadeNota: texto(urinaDensidadeNotaRef),
        ph: marcado(urinaPhRef),
        phNota: texto(urinaPhNotaRef),
        acetona: marcado(urinaAcetonaRef),
        acetonaNota: texto(urinaAcetonaNotaRef),
        bilirr: marcado(urinaBilirrRef),
        bilirrNota: texto(urinaBilirrNotaRef),
        leucocitos: marcado(urinaLeucocitosRef),
        leucocitosNota: texto(urinaLeucocitosNotaRef),
        sangue: marcado(urinaSangueRef),
        sangueNota: texto(urinaSangueNotaRef),
        sedimento: marcado(urinaSedimentoRef),
        sedimentoNota: texto(urinaSedimentoNotaRef),
      };
      formData.append("examesUrina", JSON.stringify(examesUrina));

      // Fezes
      formData.append("fezes", marcado(fezesRef));
      formData.append("fezesNota", texto(fezesNotaRef));

      /* Pelo menos um exame. Não havia validação nenhuma: uma requisição sem
         exames era gravada e impressa em branco, ou — pior — o erro que
         aparecia era o `catch` geral a falar de «processar dados», que não
         ajudava ninguém a perceber o que faltava.
         Conta as três secções, porque uma requisição só de fezes é válida. */
      const algumExame =
        Object.entries(examesSangue).some(
          ([campo, valor]) => !campo.endsWith("Nota") && valor === true,
        ) ||
        Object.entries(examesUrina).some(
          ([campo, valor]) => !campo.endsWith("Nota") && valor === true,
        ) ||
        marcado(fezesRef);

      if (!algumExame) {
        toast.error(
          "Selecione pelo menos um exame antes de criar a requisição.",
        );
        return;
      }

      try {
        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/requisicaoexames`,
          "POST",
          formData,
          {
            Authorization: "Bearer " + auth.token,
          }
        );
        toast.success("Requisição criada com sucesso!");
        handleCancel();
      } catch (err) {
        console.error("err", err);
        toast.error("Erro ao criar requisição");
      }
    } catch (err) {
      console.error(err);

      toast.error("Erro ao processar dados");
    } finally {
      stopLoading();
      /* A bandeira tem de ser desligada AQUI, e não no caminho de sucesso.
       *
       * O `preSubmitHandler` põe-na a true e o botão de gravar usa-a em
       * `disabled`. Não havia nenhum `setIsSubmitting(false)` em sítio nenhum:
       * ao primeiro erro — validação, falha de rede, qualquer um — o botão
       * ficava desativado até se recarregar a página. Ninguém liga as duas
       * coisas: vê-se a mensagem, corrige-se o que ela diz, e o botão continua
       * morto sem explicação.
       *
       * No `finally` cobre todos os caminhos, incluindo o `return` da validação
       * dos exames. No sucesso é inofensivo, porque o `handleCancel` já saiu
       * do formulário. */
      setIsSubmitting(false);
    }
  };

  const preSubmitHandler = () => {
    setIsSubmitting(true);
    onSubmit();
  };

  const idade = clienteData?.data_nasc ? calcularIdade() : "N/A";
  return (
    <>
      <div className="nova-requisicao-exames">
        <Sidebar />
        <div className="newContainer">
          {clienteData && (
            <Navbar
              title="Requisição de Exames"
              icon={AssignmentOutlinedIcon}
              paths={[
                {
                  nome: clienteData.nome,
                  link: `../../../clientes/${clienteData.id}`,
                },
                { nome: "Nova Requisição" },
              ]}
            />
          )}

          {clienteData && (
            <div className="requisicao-content caixa">
              {/* Dados do Paciente */}
              <div className="secao-dados-paciente">
                <h2 className="secao-titulo">Dados do Paciente</h2>

                <div className="form-grid">
                  <div className="form-input">
                    <input type="text" value={clienteData.nome} disabled />
                    <label className="label">Nome</label>
                  </div>

                  <div className="form-input">
                    <input
                      type="text"
                      value={clienteData.data_nasc ? clienteData.data_nasc : ""}
                      disabled
                    />
                    <label className="label">Data de Nascimento</label>
                  </div>

                  <div className="form-input">
                    <input
                      type="text"
                      value={`${idade.anos} anos, ${idade.meses} meses`}
                      disabled
                    />
                    <label className="label">Idade</label>
                  </div>

                  <div className="form-input">
                    <input
                      type="text"
                      value={
                        clienteData.genero === "masculino"
                          ? "Masculino"
                          : "Feminino"
                      }
                      disabled
                    />
                    <label className="label">Sexo</label>
                  </div>

                  <div className="form-input">
                    <select ref={naturalidadeRef} required>
                      <option value="">Selecione...</option>
                      <option value="Praia">Praia</option>
                      <option value="Mindelo">Mindelo</option>
                      <option value="Santa Maria">Santa Maria</option>
                      <option value="Assomada">Assomada</option>
                      <option value="Tarrafal">Tarrafal</option>
                      <option value="Porto Novo">Porto Novo</option>
                      <option value="São Filipe">São Filipe</option>
                      <option value="Pedra Badejo">Pedra Badejo</option>
                      <option value="Ribeira Grande">Ribeira Grande</option>
                      <option value="Sal Rei">Sal Rei</option>
                      <option value="Estrangeiro">Estrangeiro</option>
                    </select>
                    <label className="label">Naturalidade</label>
                  </div>

                  <div className="form-input">
                    <input type="text" value={clienteData.endereco} disabled />
                    <label className="label">Morada</label>
                  </div>

                  <div className="form-input">
                    <input type="text" ref={procedenciaRef} placeholder=" " />
                    <label className="label">Procedência</label>
                  </div>

                  <div className="form-input full-width">
                    <textarea
                      ref={diagnosticoRef}
                      rows="3"
                      placeholder=" "
                      style={{ resize: "vertical" }}
                    />
                    <label className="label">Diagnóstico</label>
                  </div>
                </div>
              </div>

              {/* SANGUE */}
              <div className="secao-exames">
                <h2 className="secao-titulo">SANGUE</h2>

                <div className="exames-sangue-grid">
                  {/* COLUNA 1 - LINHA 1 */}
                  <label className="checkbox-label">
                    <input type="checkbox" ref={glVermelhoRef} />
                    <span className="exame-nome">Gl vermelhos</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={glVermelhoNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={velSedimentRef} />
                    <span className="exame-nome">Vel. Sedimentação</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={velSedimentNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={glBrancosRef} />
                    <span className="exame-nome">Gl brancos</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={glBrancosNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={tHemorragiaRef} />
                    <span className="exame-nome">T. Hemorragia</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={tHemorragiaNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={hemoglobinaRef} />
                    <span className="exame-nome">Hemoglobina</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={hemoglobinaNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={tCoagulacaoRef} />
                    <span className="exame-nome">T. Coagulação</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={tCoagulacaoNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={hematocritoRef} />
                    <span className="exame-nome">Hematócrito</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={hematocritoNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={plaquetasRef} />
                    <span className="exame-nome">Plaquetas</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={plaquetasNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      ref={formulaRef}
                      onChange={handleFormulaChange}
                    />
                    <span className="exame-nome">Fórmula (%)</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={formulaNotaRef}
                      placeholder="..."
                      disabled={formulaExpanded}
                    />
                  </label>

                  {/* Subcampos da Fórmula */}
                  {formulaExpanded && (
                    <div className="formula-subcampos">
                      <div className="formula-subcampo">
                        <label>Neut.:</label>
                        <input
                          type="text"
                          ref={formulaNeutRef}
                          placeholder="%"
                        />
                      </div>
                      <div className="formula-subcampo">
                        <label>Eosin.:</label>
                        <input
                          type="text"
                          ref={formulaEosinRef}
                          placeholder="%"
                        />
                      </div>
                      <div className="formula-subcampo">
                        <label>Bas.:</label>
                        <input
                          type="text"
                          ref={formulaBasRef}
                          placeholder="%"
                        />
                      </div>
                      <div className="formula-subcampo">
                        <label>Linf.:</label>
                        <input
                          type="text"
                          ref={formulaLinfRef}
                          placeholder="%"
                        />
                      </div>
                      <div className="formula-subcampo">
                        <label>Mon.:</label>
                        <input
                          type="text"
                          ref={formulaMonRef}
                          placeholder="%"
                        />
                      </div>
                      <div className="formula-subcampo">
                        <label>NJ.:</label>
                        <input type="text" ref={formulaNjRef} placeholder="%" />
                      </div>
                    </div>
                  )}

                  <label className="checkbox-label">
                    <input type="checkbox" ref={pesqPlasmRef} />
                    <span className="exame-nome">Pesq. Plasmódio</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={pesqPlasmNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={hivRef} />
                    <span className="exame-nome">HIV 1/2</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={hivNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={hbsAgRef} />
                    <span className="exame-nome">HBS Ag</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={hbsAgNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={glicemiaRef} />
                    <span className="exame-nome">Glicémia</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={glicemiaNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={acidoUricoRef} />
                    <span className="exame-nome">Ácido Úrico</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={acidoUricoNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={amilaseRef} />
                    <span className="exame-nome">Amilase</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={amilaseNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={gotRef} />
                    <span className="exame-nome">GOT</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={gotNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={bilirrTotalRef} />
                    <span className="exame-nome">Bilirr. Total</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={bilirrTotalNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={gamaGtRef} />
                    <span className="exame-nome">Gama GT</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={gamaGtNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={gptRef} />
                    <span className="exame-nome">GPT</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={gptNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={bilirrDirectaRef} />
                    <span className="exame-nome">Bilirr. Directa</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={bilirrDirectaNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={fosfAlcalinaRef} />
                    <span className="exame-nome">Fosf. Alcalina</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={fosfAlcalinaNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={colesterolRef} />
                    <span className="exame-nome">Colesterol</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={colesterolNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={ureiaRef} />
                    <span className="exame-nome">Ureia</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={ureiaNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={colLdlRef} />
                    <span className="exame-nome">Col. LDL</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={colLdlNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={triglicerideosRef} />
                    <span className="exame-nome">Triglicerídeos</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={triglicerideosNotaRef}
                      placeholder="..."
                    />
                  </label>

                  {/* LINHA 8 */}

                  <label className="checkbox-label">
                    <input type="checkbox" ref={colHdlRef} />
                    <span className="exame-nome">Col. HDL</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={colHdlNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={creatininaRef} />
                    <span className="exame-nome">Creatinina</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={creatininaNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={vdrlRef} />
                    <span className="exame-nome">VDRL</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={vdrlNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={tphaRef} />
                    <span className="exame-nome">TPHA</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={tphaNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={widalRef} />
                    <span className="exame-nome">WIDAL</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={widalNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={pcrRef} />
                    <span className="exame-nome">PCR</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={pcrNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={tasoRef} />
                    <span className="exame-nome">TASO</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={tasoNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={frRaRef} />
                    <span className="exame-nome">FR/RA</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={frRaNotaRef}
                      placeholder="..."
                    />
                  </label>
                </div>
              </div>

              {/* URINA */}
              <div className="secao-exames">
                <h2 className="secao-titulo">URINA</h2>

                <div className="exames-urina-grid">
                  <label className="checkbox-label checkbox-label__span-3">
                    <input type="checkbox" ref={urinaCaracteresRef} />
                    <span className="exame-nome">Caracteres gerais</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={urinaCaracteresNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={urinaGlicosuriaRef} />
                    <span className="exame-nome">Tira: Glicosúria</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={urinaGlicosuriaNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={urinaAlbuminaRef} />
                    <span className="exame-nome">Albumina</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={urinaAlbuminaNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={urinaDensidadeRef} />
                    <span className="exame-nome">Densidade</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={urinaDensidadeNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={urinaPhRef} />
                    <span className="exame-nome">pH</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={urinaPhNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={urinaAcetonaRef} />
                    <span className="exame-nome">Acetona</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={urinaAcetonaNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={urinaBilirrRef} />
                    <span className="exame-nome">Bilirr.</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={urinaBilirrNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={urinaLeucocitosRef} />
                    <span className="exame-nome">Leucócitos</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={urinaLeucocitosNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label">
                    <input type="checkbox" ref={urinaSangueRef} />
                    <span className="exame-nome">Sangue</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={urinaSangueNotaRef}
                      placeholder="..."
                    />
                  </label>

                  <label className="checkbox-label checkbox-label__span-3">
                    <input type="checkbox" ref={urinaSedimentoRef} />
                    <span className="exame-nome">Sedimento</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={urinaSedimentoNotaRef}
                      placeholder="..."
                    />
                  </label>
                </div>
              </div>

              {/* FEZES */}
              <div className="secao-exames">
                <h2 className="secao-titulo">FEZES</h2>

                <div className="exames-fezes-grid">
                  <label className="checkbox-label checkbox-label__span-3">
                    <input type="checkbox" ref={fezesRef} />
                    <span className="exame-nome">Exame de Fezes</span>
                    <input
                      type="text"
                      className="nota-exame"
                      ref={fezesNotaRef}
                      placeholder="..."
                    />
                  </label>
                </div>
              </div>

              {/* Botões */}
              <div className="botoes">
                <button
                  type="button"
                  className="blue-button"
                  disabled={isSubmitting}
                  onClick={preSubmitHandler}
                >
                  Guardar
                </button>
                <button
                  type="button"
                  className="cancel-btn botao"
                  onClick={handleCancel}
                >
                  Cancelar
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default RequisicaoExames;
